import { useEffect, useRef, useState } from 'react';
import { Banner, BlockStack, Button, Modal, Text } from '@shopify/polaris';
import { useApi } from '../../hooks/useApi';

export default function RouteManifestPreview({routeId, onClose}: {routeId: string; onClose: () => void}) {
  const {fetchApi, error} = useApi();
  const [document, setDocument] = useState('');
  const [ready, setReady] = useState(false);
  const [printError, setPrintError] = useState(false);
  const frame = useRef<HTMLIFrameElement>(null);
  useEffect(() => {
    let current = true;
    setDocument('');
    setReady(false);
    void fetchApi<{html:string}>('/routes/' + routeId + '/manifest').then(result => {
      if (current && result) setDocument(result.html);
    });
    return () => { current = false; };
  }, [fetchApi, routeId]);
  function print() {
    try {
      frame.current?.contentWindow?.focus();
      frame.current?.contentWindow?.print();
    } catch {
      setPrintError(true);
    }
  }
  return <Modal open size="large" title="Route manifest and delivery notes" onClose={onClose}>
    <Modal.Section><BlockStack gap="300">
      {error && <Banner tone="critical">{error}</Banner>}
      {printError && <Banner tone="warning">Allow printing for this page, then try again.</Banner>}
      {!document && !error && <Text as="p" aria-live="polite">Loading route manifest…</Text>}
      {document && <>
        <div><Button variant="primary" disabled={!ready} onClick={print}>Print or save PDF</Button></div>
        <iframe ref={frame} title="Route manifest print preview" srcDoc={document}
          sandbox="allow-same-origin allow-modals" onLoad={() => setReady(true)}
          style={{width:'100%', height:'60vh', border:0}} />
      </>}
    </BlockStack></Modal.Section>
  </Modal>;
}
